export const AppLinks = {
   home: '/',
   start: '/start',
   return: '/return',
   sessionEnd: '/sesja-wygasla',
   error: '/cos-poszlo-nie-tak',
   houston: '/brak-internetu',
   waiting: '/daj-nam-chwile',
   
   success: '/decyzja-pozytywna',
   fail: '/odmowa',
   cancel: '/wniosek-anulowany',
   bmverify: '/wybierz-bank',
   bmWaiting: '/analizujemy-dane',
   productPage: '/dopasuj-produkt',
   contractSigning: '/podpisz-umowe',
   retention: '/retencja',
   clientPeselReservedPage: '/numer-pesel-zarezerwowany',

   basicInfoForm: process.env.NODE_ENV === 'development' ? '/formularz/dane-kontaktowe' : process.env.REACT_APP_FORM_STARTING_URL_PATH ?? '',
   addressInfoForm: '/formularz/dane-adresowe',
   extendedInfoForm: '/formularz/dane-osobowe',
   trastiCollectPersonalIdForm: '/formularz/trasti-dodatkowa-weryfikacja',
   chooseIdentityMethod: '/formularz/wybierz-sposob-potwierdzenia-danych',
   chooseVerificationMethod: '/sposob-weryfikacji-danych',

   // MOBYWAEL
   mObywatelExtendedInfoForm: '/formularz/dodatkowy-formularz-mobywatel',
   mObywatelIdentityMethod: '/formularz/kod-mobywatel',
   mObywatelVerificationMethod: '/kod-mobywatel',

   // WIDEO WERYFIKACJA
   videoVerificationStartIdentificationPage: '/wideo-weryfikacja-weryfikuj-dane',
   videoVerificationStartVerificationPage: '/wideo-weryfikacja-potwierdz-dane',
   
   videoVerificationIdentificationErrorPage: '/wideo-weryfikacja-blad-weryfikacji-danych',
   videoVerificationVerificationErrorPage: '/wideo-weryfikacja-blad-potwierdzenia-danych',

   videoVerificationBasicInfoForm: '/formularz/wideo-weryfikacja-dane-podstawowe',
   videoVerificationAddressInfoForm: '/formularz/wideo-weryfikacja-dane-adresowe',
   videoVerificationBackFromPartner: '/wideo-weryfikacja-powrot',


   docsToDownload: process.env.NODE_ENV === 'development' ? 'dokumenty' : process.env.REACT_APP_REPRESENTATIVE_PAGE_DOC_TO_DOWNLOAD_URL_PATH ?? '',

   // howItWorks: process.env.NODE_ENV === 'development' ? 'jak-to-dziala' : process.env.REACT_APP_REPRESENTATIVE_PAGE_HOW_IT_WORKS_URL_PATH ?? '',
}